import React from 'react'

const VendorPayments = () => {
  return (
    <div>VendorPayments</div>
  )
}

export default VendorPayments